import qsStringify from "./qsStringify";
import api from "./api";

export const getHeaderLogos = locale => {
  const query = qsStringify({
    populate: ["first", "second"],
  });
  return api
    .get(`/header-logo?locale=${locale}&${query}`)
    .then(res => res.data);
};

export const getSocialLinks = locale => {
  const query = qsStringify({
    populate: ["social_links"],
  });
  return api
    .get(`/social-link?locale=${locale}&${query}`)
    .then(res => res.data);
};

export const getFooter = locale => {
  const query = qsStringify({
    populate: [
      "head_office",
      "complex",
      "related_sites",
      "shortcuts",
      "social_links",
      "logo",
    ],
  });
  return api.get(`/footer?locale=${locale}&${query}`).then(res => res.data);
};

export const subscribe = body => {
  return api.post(`/footer-subscribes`, body).then(res => res.data);
};

export const getPageInfo = (endpoint, locale, populate) => {
  const query = qsStringify({
    locale,
    populate: [
      "page_info.seo_info",
      "page_info.seo_info.image",
      "page_info.banner",
      ...(!!populate ? populate : []),
    ],
  });
  return api.get(`${endpoint}?${query}`).then(res => res.data);
};

export const getSkillPageDocument = locale => {
  const query = qsStringify({
    populate: ["documents.file"],
    locale,
  });
  return api.get(`/page-skill?${query}`).then(res => res.data);
};
